import React, { Component, ReactElement } from 'react'
import { LanguageContextProvider } from '../../React/Common/Contexts'
import { Route } from '../Annotation/Route'
import { RouteID } from '../Components/Molecules/Header/Types/Types'
import { RouteGuard } from '../Guards/RouteGuard'
import { ServerStatusFeatureGate } from '../Guards/ServerStatusFeatureGate'
import { ServerStatus } from '../Components/Organisms/ServerStatus/ServerStatus'

/**
 * Routed page wrapper for the application server status page.
 */
@Route(RouteID.STATUS)
export class ServerStatusPage extends Component {
    /**
     * Renders the guarded routed page.
     *
     * @returns Application server status page component tree.
     */
    render(): ReactElement {
        return (
            <RouteGuard route={RouteID.STATUS}>
                <ServerStatusFeatureGate>
                    <LanguageContextProvider>
                        <ServerStatus />
                    </LanguageContextProvider>
                </ServerStatusFeatureGate>
            </RouteGuard>
        )
    }
}
